<app-contract-form
  [edit]="false"
  [create]="true"
  [delete]="false"
  [details]="false"
  [access]="access()"
></app-contract-form>
